"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatUrl = void 0;
const url_1 = require("url");
exports.formatUrl = (url) => {
    if (!url) {
        return undefined;
    }
    try {
        const uu = url_1.parse(url);
        if (uu.protocol === "http:" || uu.protocol === "https:") {
            return url;
        }
    }
    catch (_a) {
        return undefined;
    }
    return undefined;
};
//# sourceMappingURL=formatUrl.js.map